<template>
  <div class="resultCreateDebt_warpper">
    <nav-bar titleText="审核结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <results-page
      @handleOperationClick="handleOperationClick"
      @handleReturnClick="handleReturnClick"
      operationDisplab
      operationText="再次申请" 
      returnDisplab
      returnText="返回"
      :imgSrc="imgSrc"
      instructions="已成功提交审核"
    >
      <template #default>
        <p class="title">认证被驳回</p>
        <!-- <p class="content">驳回原因：四大皆空了；罚款了时间的法律框架阿斯顿发就离开</p> -->
        <p class="content">{{ rejectReason }}</p>
      </template>
    </results-page>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import resultsPage from "../components/resultsPage";
export default {
  name: "debt_resultSignature",
  data() {
    return {
     imgSrc: require("../../../assets/debtor/authReject.png"),
     rejectReason: this.$route.query.rejectReason,
    };
  },
  created() {},
  components: {
    navBar,
    resultsPage,
  },
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.$router.push({
        path: '/debtRelief/wrDebtPersonHome',
        query: {
          token: localStorage.getItem('_token') || this.$route.query.token,
        },
      })

    },
    handleOperationClick() {
      // TODO 再次申请 跳转原生
      // const param = {}
      // this.params(JSON.stringify(param), JSON.stringify(param), 'debtApplyAgain')
      this.$router.push({
        path: '/identity/authenticate',
        query: {
          token: localStorage.getItem('_token') || this.$route.query.token,
        },
      })
    },
    // 返回事件，返回债务人首页
    handleReturnClick() {
      // this.$router.push('/debtor/debtorView')
      // this.$router.go(-1);

      this.$router.push({
        path: '/identity/authenticate',
        query: {
          token: localStorage.getItem('_token') || this.$route.query.token,
        },
      })
    }
  }
};
</script>
<style lang="less">
.resultCreateDebt_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  min-height: 100%;
  font-size: 16px;
  color: #333;
  .title {
    height: 21px;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    margin-bottom: 12px;
  }
  .content {
    margin: 0 auto 36px;
    width: 244px;
    // height: 48px;
    font-size: 15px;
    color: #666666;
    line-height: 24px;
  }
}
</style>
